<template>
  <div id='myname-container'>
    <div class="greeter myname">
      <h1><span class='main'>福田ゆり</span><span class='side'>Yuri Fukuda</span></h1>
      <div class="subscript" v-on:click="onsubscliptclick">art <span class="cross">x</span> technology <br/>community</div>

    </div>
<!--     <div class="greeter">
    </div>
 -->  </div>

</template>
<script>
export default{

    watch:{
      $route (to, from){
          this.update( to.name );
      }
    },
    methods:{
      onsubscliptclick( event ){
        this.$router.push('about');
      },
      update( routerName ) {
        const _routerName = routerName || "Home";
        if( _routerName == "Home"){
          if( !this.$el.classList.contains("main") ){
            this.$el.classList.remove('side');
            this.$el.classList.add('main');
          }
        } else {
          if( !this.$el.classList.contains("side") ){
            this.$el.classList.remove('main');
            this.$el.classList.add('side');
          }
        }
      }
    }

}
</script>
<style lang="scss">
  #myname-container{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index:1;

    .greeter.myname {
      transition: all 1s ease-in-out 0.5s;
      display:inline-block;
      position:absolute;
      top: 0px;
      right:-20px;
    }

    .greeter.myname h1{
      font-family: "GT-Super-Text-Book-Italic";
      padding: 0;

      > span.side,
      > span.main{
        display:none;
        color: #f5f5f969;
      }
    }


    .subscript{
      cursor:pointer;
      color: var(--basecolor);
      display: inline-block;
      position: relative;
      text-align: center;
      font-size: 2vh;
      width: 100%;
      opacity: 0.6;
    }    


    &.side{
      right: 30px;
      left: auto;
      .greeter.myname{
        width: max-content;
        top: 0px;
        right:0px;
      }

      .greeter.myname h1{
        font-size: 2em;
        margin: 0px 0px 20px 0px;
        > span.side{
          display:inline;
        }

      }
      .subscript {
        display:none;
      }
  
    }
    
    &.main{
      text-align: center;

      .greeter.myname {
        width: max-content;
        right: 5vw;
      }
      .greeter.myname h1{

        font-size: 10vh;
        margin: 0px;
        white-space: nowrap;
        font-family: "Sawarabi Mincho", sans-serif;
        display: inline-block;
        width: 1em;
        word-break: break-all;
        white-space: break-spaces;

        > span.main{
          display:inline;
          word-spacing: 3em;


        }


      }
      .subscript{
        color: var(--basecolor);
        font-size: 2.5vh;
        display: inline-block;
        position: absolute;
        width: auto;
        line-height: 1.5em;
        text-align: center;
        opacity: 0.6;
        transform: rotateZ(90deg);
        float: right;
        transform-origin: top left;
        text-align: left;
        top: 5vh;
        right: 1em;

      }    

    }
  }

</style>